module.exports = __webpack_public_path__ + "img/branton-universe-case.f6ce0b24.jpg";